const materialTypeUrl = '/app/material-category';

export const getMaterialTypePage = () => `${materialTypeUrl}`;
export const createMaterialType = () => `${materialTypeUrl}`;
export const updateMaterialType = (id) => `${materialTypeUrl}/${id}`;
export const deleteMaterialType = (id) => `${materialTypeUrl}/${id}`;
export const materialTypeComplex = (id) => `${materialTypeUrl}/${id}/complex`;

export const getAllMaterialTypeTree = () =>
  `${materialTypeUrl}/material-category-tree`
